import { Injectable } from '@angular/core';
import { IKpi, AverageKpi, SumKpi } from '../../models/kpi';
import * as _ from 'lodash';

@Injectable()
export class KpiProvider {
  averageKpis = ['KpiAf', 'KpiRf'];
  sumKpis = ['KpiSh', 'KpiRt', 'KpiSs', 'KpiPwrGen'];

  computeKpis(rawKpis: Array<any>, rawPrevKpis: Array<any>): { [key: string]: IKpi } {
    let kpisInfo: { [key: string]: IKpi } = {};

    for (let kpiName of this.averageKpis) {
      kpisInfo[kpiName] = new AverageKpi(kpiName).compute(rawKpis, rawPrevKpis).format(1);
    }

    for (let kpiName of this.sumKpis) {
      kpisInfo[kpiName] = new SumKpi(kpiName).compute(rawKpis, rawPrevKpis).format(1);
    }


    if (kpisInfo['KpiPwrGen'].hasData && kpisInfo['KpiSh'].hasData) {
      kpisInfo['AveragePower'] = _.cloneDeep(kpisInfo['KpiPwrGen']).convert((current: number) => {
        return current / kpisInfo['KpiSh'].currentValue / 1000;
      }, (previous: number) => {
        if (kpisInfo['KpiSh'].previousValue > 0 && previous > 0) {
          return previous / kpisInfo['KpiSh'].previousValue / 1000;
        }
        return 0;
      }).format(1);

      kpisInfo['Energy'] = _.cloneDeep(kpisInfo['KpiPwrGen']).convert((current: number) => {
        return current / 1000;
      }, (previous: number) => {
        if (previous > 0) {
          return previous / 1000;
        }
        return 0;
      }).format(1);
    }
    return kpisInfo;
  }

}



// WEBPACK FOOTER //
// ./src/providers/kpi/kpi.ts